var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"
})));
export default __webpack_public_path__ + "static/media/seta-esquerda.7f9ab628.svg";
export { SvgComponent as ReactComponent };